import axios from "axios";
const BASE_URL =
    process.env.REACT_APP_API_URL;

// ==============================
// GET CLIENT MANAGEMENT USERS
// ==============================

export const getClientManagementUsers =
    async (token) => {

        try {

            const response = await axios.get(
                `${BASE_URL}/subscription/api/admin/enquiries/getall`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":
                            "application/json",
                    },
                }
            );

            return response.data;

        } catch (error) {

            console.error(
                "GET Client Management Error:",
                error
            );

            throw error;
        }
    };


export const getVendorDetails =
    async (vendorId, token) => {

        try {



            const response =
                await axios.get(
                    `${BASE_URL}/food/api/vendors/${vendorId}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Vendor Details Error:",
                error
            );

            throw error;
        }
    };


export const updateVendorDetails =
    async (
        vendorId,
        formData,
        token
    ) => {

        try {

            const response =
                await axios.put(
                    `${BASE_URL}/food/api/vendors/edit/${vendorId}`,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "UPDATE Vendor Error:",
                error
            );

            throw error;
        }
    };

export const verifyVendorStatus =
    async (
        vendorId,
        vendorData,
        token
    ) => {

        try {



            const formData =
                new FormData();

            formData.append(
                "vendorData",

                new Blob(
                    [
                        JSON.stringify(
                            vendorData
                        ),
                    ],

                    {
                        type:
                            "application/json",
                    }
                )
            );

            const response =
                await axios.put(
                    `${BASE_URL}/food/api/vendors/edit/${vendorId}`,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "VERIFY Vendor Error:",
                error
            );

            throw error;
        }
    };

export const getAllEnquiries =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/subscription/api/admin/enquiries/getall`,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Enquiries Error:",
                error
            );

            throw error;
        }
    };

export const approveVendor =
    async (
        vendorId,
        body,
        token
    ) => {

        try {

            const FOOD_BASE_URL =
                BASE_URL.replace(
                    "/subscription/api",
                    ""
                );

            const response =
                await axios.put(
                    `${FOOD_BASE_URL}/food/api/vendors/admin/vendor-registration/approval/${vendorId}`,
                    body,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "APPROVE Vendor Error:",
                error
            );

            throw error;
        }
    };

export const getSubscriptions = async (token) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/subscription/api/subscription/admin/subscriptions?businessVertical=FOOD_AND_BEVERAGES`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET Subscriptions Error:", error);
        throw error;
    }
};


export const getPartnerDetails = async (partnerId, token) => {
    try {

        const FOOD_BASE_URL = BASE_URL.replace("/subscription/api", "");

        const response = await axios.get(
            `${FOOD_BASE_URL}/delivery/api/get/${partnerId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET Partner Details Error:", error);
        throw error;
    }
};

export const updatePartnerDetails = async (partnerId, formData, token) => {
    try {

        const FOOD_BASE_URL = BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${BASE_URL}/delivery/api/registration/update/${partnerId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("UPDATE Partner Error:", error);
        throw error;
    }
};


export const getAllPartners = async (token) => {
    try {

        const FOOD_BASE_URL = BASE_URL.replace("/subscription/api", "");

        const response = await axios.get(
            `${FOOD_BASE_URL}/delivery/api/admin/get/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET All Partners Error:", error);
        throw error;
    }
};
export const getAllDeliveryPartners = async (token) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.get(
            `${FOOD_BASE_URL}/delivery/api/admin/get/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("GET Delivery Partners Error:", error);

        throw error;
    }
};

export const verifyPartnerField = async (
    partnerId,
    formData,
    token
) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${FOOD_BASE_URL}/delivery/api/registration/update/${partnerId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("VERIFY Partner Error:", error);

        throw error;
    }
};
export const rejectPartnerField = async (
    partnerId,
    formData,
    token
) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${FOOD_BASE_URL}/delivery/api/registration/update/${partnerId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("REJECT Partner Error:", error);

        throw error;
    }
};

export const approvePartner = async (
    partnerId,
    payload,
    token
) => {
    try {



        const response = await axios.put(
            `${BASE_URL}/delivery/api/admin/approval/${partnerId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("APPROVE Partner Error:", error);

        throw error;
    }
};

export const rejectPartnerApproval = async (
    partnerId,
    requestBody,
    token
) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${FOOD_BASE_URL}/delivery/api/admin/approval/${partnerId}`,
            requestBody,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("REJECT Partner Approval Error:", error);

        throw error;
    }
};
export const fetchAllOffers = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) {
        throw new Error("No auth token found");
    }

    const response = await fetch(
        `${BASE_URL}/delivery/api/admin/get/all/offers`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};


